// PURPOSE: Stable local initials avatars shared by person surfaces.
// CONTRACT: Specs 066/068; local initials fallback for a caller-provided private picture.
// DEPENDS: Existing design system tokens.
// CEILING: Presentation only.
import { useState } from 'react';
const colours = ['brand', 'success', 'warning', 'danger', 'brand-hover', 'text-muted', 'text-subtle', 'text'];
export function avatarColour(id: string) {
 let hash = 0; for (const character of id) hash = (Math.imul(hash, 31) + character.charCodeAt(0)) | 0;
 return colours[(hash >>> 0) % colours.length];
}
export function PersonAvatar({ id, name, picture }: { id: string; name: string; picture?: string }) {
 const [failed,setFailed]=useState<string>();
 const initials = name.trim().split(/\s+/).slice(0, 2).map(part => part[0] || '').join('').toUpperCase() || '?';
 return <span className="avatar" aria-hidden="true" style={{ background: `var(--${avatarColour(id)})`, color: 'var(--on-brand)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, flex: '0 0 28px', borderRadius: '50%', fontSize: 12 }}>{picture && failed!==picture ? <img src={picture} alt="" onError={()=>setFailed(picture)} style={{width:28,height:28,borderRadius:"50%",objectFit:"cover"}}/> : initials}</span>;
}
